import { render, staticRenderFns } from "./add-update-user-role.vue?vue&type=template&id=d0e41b3e&scoped=true&"
import script from "./add-update-user-role.vue?vue&type=script&lang=js&"
export * from "./add-update-user-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e41b3e",
  null
  
)

export default component.exports